import { useFormContext } from 'react-hook-form'

import { FormError, SearchSelect } from '@fortem-monorepo/react-ui'
import { FormField, FormItem, FormLabel } from '@fortem-monorepo/react-ui'

export interface TraderIdFormFieldProps {
  traders?: { label: string; value: number }[]
  loading?: boolean
  disabled?: boolean
}

export const TraderIdFormField: React.FC<TraderIdFormFieldProps> = ({
  traders,
  loading,
  disabled,
}) => {
  const { control, setValue } = useFormContext<{ trader_id: number | null }>()

  return (
    <FormField
      name="trader_id"
      control={control}
      render={({ field }) => {
        return (
          <FormItem>
            <div className="flex items-center gap-2">
              <FormLabel>Trader</FormLabel>
              <FormError />
            </div>
            <SearchSelect
              showNone={'None'}
              placeholder={'Select a trader'}
              loading={loading}
              disabled={disabled}
              value={field.value?.toString()}
              options={traders?.map(({ label, value }) => ({ label, value: value?.toString() }))}
              setValue={(val) =>
                setValue('trader_id', val ? parseInt(val) : null, { shouldValidate: true })
              }
            />
          </FormItem>
        )
      }}
    />
  )
}
